import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import type { TOrderFormParams } from '../types/order-form-params.type'
import { getOperationsOrderService } from '../services/get-operations-order.service'

type OrderFormParamsQueryProps = {
  companyId: string
}

export function useOrderFormGetOperationsQuery({
  companyId,
}: OrderFormParamsQueryProps) {
  const { data: orderFormOperations, refetch: refetchOrderFormGetOperations } =
    useQuery<TOrderFormParams>({
      queryKey: [QUERY_KEYS.ORDER_FORM_OPERATION, companyId],
      enabled: false,
      queryFn: async () => {
        const response = await getOperationsOrderService({
          companyId,
        })

        const data = JSON.parse(response.body)
        return data
      },
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })
  return {
    orderFormOperations,
    refetchOrderFormGetOperations,
  }
}
